/** @format */
'use client';
import { useConfigStore } from '@/providers/ConfigStoreProvider';
import { Currency } from '@common/model/apiClient/Currency';
import { ICurrency } from '@common/types/currency';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuery } from '@tanstack/react-query';
import { SelectBox } from 'devextreme-react/select-box';
import React from 'react';
import { useIntl } from 'react-intl';
import styles from './UserMenu.module.css';

const CurrencyRender = (currency: ICurrency) => {
  return (
    <div className={styles.currencyItem}>
      {/*{currency.icon}*/}
      <FontAwesomeIcon icon={['fas', currency.iconName as IconName]} />
      {currency.iso4217}
    </div>
  );
};

function CurrencySelect() {
  const { currency, setCurrency } = useConfigStore((s) => s);
  // const { currencies, changeCurrency, selectedCurrency } = useContext(CurrencyContext);
  const intl = useIntl();

  const currencyData = useQuery({
    queryKey: ['currencies_not_deleted'],
    queryFn: () => Currency.list(),
    refetchOnWindowFocus: false,
    refetchInterval: false,
    retry: 1,
    placeholderData: (previousData) => previousData,
  });

  const onValueChange = (e: string) => {
    console.log(e);
    if (!e) return;
    const newCurrency = currencyData.data?.payload.find((c) => c.iso4217 === e);
    if (newCurrency) {
      setCurrency(newCurrency);
    }
  };

  return (
    <SelectBox
      label={intl.formatMessage({ defaultMessage: 'Select Currency' })}
      dataSource={currencyData.data?.payload ?? []}
      displayExpr={'id'}
      valueExpr={'iso4217'}
      itemRender={CurrencyRender}
      value={currency.iso4217}
      onValueChange={onValueChange}
    ></SelectBox>
  );
}

export default CurrencySelect;
